/* bag-store.js — DRO-69 motion. Poster first, video second, never at LCP cost. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  var thrifty = reduce || conn.saveData === true || /2g/.test(conn.effectiveType || '');
  var desktop = window.matchMedia('(min-width: 750px)').matches;

  function whenNear(el, cb) {
    if (!('IntersectionObserver' in window)) return cb();
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); cb(); } });
    }, { rootMargin: '100% 0px' });
    io.observe(el);
  }

  /* Hero: the poster is the LCP element. The video attaches after load and fades in. */
  function initHero(root) {
    var video = root.querySelector('video[data-bag-hero]');
    if (!video || thrifty) return;
    function attach() {
      whenNear(root, function () {
        Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function (s) {
          s.src = s.dataset.src;
        });
        video.load();
        video.addEventListener('loadeddata', function () {
          video.classList.add('is-ready');
          var p = video.play();
          if (p && p.catch) p.catch(function () { video.classList.remove('is-ready'); });
        }, { once: true });
      });
    }
    if (document.readyState === 'complete') attach();
    else window.addEventListener('load', attach, { once: true });
  }

  /* Horizon scrolls an inner .page-wrapper (body is overflow:hidden), so a window scroll
     listener never fires. Bind to the nearest scrollable ancestor and to window, since a
     different theme, or a section pulled into a template that scrolls normally, needs window.
     getBoundingClientRect stays viewport-relative either way, so pct() needs no change. */
  function scrollTargets(el) {
    var out = [window], n = el && el.parentElement;
    while (n && n !== document.body) {
      var oy = getComputedStyle(n).overflowY;
      if (oy === 'auto' || oy === 'scroll') { out.push(n); break; }
      n = n.parentElement;
    }
    return out;
  }
  function onScrollAll(el, fn) {
    scrollTargets(el).forEach(function (t) { t.addEventListener('scroll', fn, { passive: true }); });
  }

  /* Scroll sequence. Desktop scrubs an MP4; mobile paints a WebP frame set on canvas.
     iOS will not seek a <video> frame-accurately from a scroll handler — see DRO-69 §2b. */
  function initScroll(root) {
    var stage = root.querySelector('[data-bag-stage]');
    if (!stage || thrifty) return;
    var progress = 0, ticking = false;

    function pct() {
      var r = root.getBoundingClientRect();
      var span = r.height + window.innerHeight;
      return Math.min(1, Math.max(0, (window.innerHeight - r.top) / span));
    }

    if (desktop && stage.dataset.video) {
      var v = document.createElement('video');
      v.muted = true; v.playsInline = true; v.preload = 'auto'; v.src = stage.dataset.video;
      whenNear(root, function () {
        v.addEventListener('loadedmetadata', function () {
          stage.appendChild(v); v.classList.add('is-ready');
          onScrollAll(root, onScroll);
          onScroll();
        }, { once: true });
        v.load();
      });
      var apply = function () {
        ticking = false;
        if (v.duration) v.currentTime = v.duration * progress;
      };
      var onScroll = function () {
        progress = pct();
        if (!ticking) { ticking = true; requestAnimationFrame(apply); }
      };
      return;
    }

    var frames = [];
    try { frames = JSON.parse(stage.dataset.frames || '[]'); } catch (e) { frames = []; }
    if (!frames.length) return;
    var canvas = stage.querySelector('canvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var imgs = [], settled = 0, sized = false, last = -1;

    /* Count errors as settled, not just loads. If one frame 404s, the section must
       still scrub on the eleven that arrived — an un-incremented counter would leave
       the scroll listener unattached and freeze the canvas on frame 0 with no error
       anywhere. Canvas is sized by the first frame that decodes, not by index 0, so a
       missing first frame does not leave the canvas at its 300x150 default. */
    function settle() {
      settled++;
      if (settled === frames.length) {
        onScrollAll(root, onScroll);
        onScroll();
      }
    }

    whenNear(root, function () {
      frames.forEach(function (src, i) {
        var im = new Image();
        im.decoding = 'async';
        im.onload = function () {
          if (!sized) {
            sized = true;
            canvas.width = im.naturalWidth;
            canvas.height = im.naturalHeight;
            draw(i);
          }
          settle();
        };
        im.onerror = function () { imgs[i] = null; settle(); };
        im.src = src;
        imgs[i] = im;
      });
    });

    function draw(i) {
      if (i === last || !sized || !imgs[i] || !imgs[i].complete || !imgs[i].naturalWidth) return;
      last = i;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(imgs[i], 0, 0, canvas.width, canvas.height);
      /* The canvas is stacked ON the poster and stays transparent until a frame is actually
         painted, so a frame set that never decodes leaves the poster visible instead of a blank. */
      canvas.classList.add('is-painted');
    }
    function paint() {
      ticking = false;
      draw(Math.min(frames.length - 1, Math.round(progress * (frames.length - 1))));
    }
    function onScroll() {
      progress = pct();
      if (!ticking) { ticking = true; requestAnimationFrame(paint); }
    }
  }

  /* Colour picker: swaps the bag and repaints the field behind it. No page reload.

     DRO-91 §6. Two bugs lived here. (1) The <img> carries a srcset for the three widths, and
     a srcset ALWAYS beats src - so assigning src alone left the first bag on screen for every
     swatch while the background changed underneath it. Measured on the live site: three
     clicks, three background colours, one image (C1_colour_4x5_WHT.webp) every time. That is
     precisely the "the page glitched" the founder reported. srcset is now swapped first, then
     src. (2) The field was painted with the bag's OWN colour, so a white bag sat on a white
     field. data-field now arrives from the section Liquid.

     DRO-119. data-field is no longer a derived pair - it is the field already baked into the
     render, so the section repeats it and the file reads full bleed with no seam. One of the
     three (plum, behind Pink) is dark, and ink on plum measures 1.4:1. isDark() flips the
     section to light type from the hex itself rather than from the colour name, so a future
     dark field is handled without another code change. */
  function isDark(hex) {
    var h = String(hex || '').trim().replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (!/^[0-9a-fA-F]{6}$/.test(h)) return false;
    var c = [0, 2, 4].map(function (i) {
      var v = parseInt(h.substr(i, 2), 16) / 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    /* Relative luminance (WCAG 2.x). Below 0.18 the ink pair drops under 4.5:1. */
    return (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) < 0.18;
  }
  function initPicker(root) {
    var btns = root.querySelectorAll('[data-bag-colour]');
    var img = root.querySelector('[data-bag-colour-image]');
    var cta = root.querySelector('[data-bag-colour-cta]');
    function paintField(hex) {
      if (!hex) return;
      root.style.setProperty('--bag-field', hex);
      root.classList.toggle('is-dark-field', isDark(hex));
    }
    /* The first swatch is rendered pressed by Liquid; sync the ink to it on load so the
       initial paint is never a dark field with dark type. */
    var firstBtn = btns[0];
    if (firstBtn) paintField(firstBtn.dataset.field);
    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(btns, function (o) { o.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        paintField(b.dataset.field);
        if (b.dataset.ar) root.style.setProperty('--bag-media-ar', b.dataset.ar);
        if (cta && b.dataset.href) cta.setAttribute('href', b.dataset.href);
        if (img && b.dataset.image) {
          root.classList.add('is-swapping');
          var next = new Image();
          /* Preload through the same responsive set the <img> will use, so the browser
             paints from cache and the fade has nothing to wait for. */
          if (b.dataset.srcset) { next.srcset = b.dataset.srcset; next.sizes = img.sizes; }
          var show = function () {
            if (b.dataset.srcset) img.srcset = b.dataset.srcset; else img.removeAttribute('srcset');
            img.src = b.dataset.image;
            img.alt = b.dataset.alt || img.alt;
            root.classList.remove('is-swapping');
          };
          next.onload = show;
          next.onerror = show;   /* never strand the section at opacity:0 on a 404 */
          next.src = b.dataset.image;
        }
      });
    });
  }

  /* Product page: the same pairing on the variant switch, so the two pages agree.

     Horizon fits product media with object-fit:contain and paints the letterbox with
     --color-background. Setting that variable per selected colour is the whole effect and it
     needs no app: picking Pink tints the gallery plum, exactly as the home section does.
     The value is set on <html> rather than on the gallery because Horizon REPLACES the gallery
     element on a variant change - a property set on the old node would be thrown away. The
     colour name comes from the radio's value, which is the product option value, so the
     mapping is keyed on the same three words the home section uses. */
  /* DRO-119: the founder's fixed pairing, identical to the field baked into each Shot 1
     render and to field_hex on the home colour picker blocks. Not derived from order.
     DRO-124: White moved E0AE44 -> DDAB3E. The gallery now carries the six-shot White
     render pack, and DDAB3E is the MEASURED median of the field baked into those files
     (measure.py, median of per-file medians), not a guessed hex. Shot 1 alone sits a
     touch brighter at E5B13E; the mat matches the five 4:5 files it borders most. */
  /* DRO-128: re-measured against the tile-1 files that are actually live now. Each value is
     the MEAN of every pixel of the flat 1:1 render that the matching cutout made transparent,
     i.e. the file's own field and nothing else - 238k/246k/251k pixels sampled, not a stated
     hex and not a corner sample. Yellow moves DBD8DE -> DCDAE4: the same off-white the Yellow
     render was shot on, warmer than the grey it read as. */
  var PAIR = { white: '#E3B03E', pink: '#411929', yellow: '#DCDAE4' };
  function setPair(hex) {
    if (!hex) return;
    document.documentElement.style.setProperty('--bag-pair', hex);
    /* DRO-125: the cutout's drop shadow needs a different strength on a dark field, and CSS
       cannot ask whether a custom property is dark. Same isDark() the home picker uses, so
       the two pages agree and a future dark pair needs no further edit. */
    document.documentElement.classList.toggle('is-dark-pair', isDark(hex));
  }
  function pairFromName(name) {
    return PAIR[String(name || '').trim().toLowerCase()] || '';
  }
  function initVariantPair() {
    var picker = document.querySelector('.variant-picker');
    if (!picker) return;
    function sync() {
      /* NOT querySelector('...:checked, ...[checked]'): Horizon renders the default option
         with a checked ATTRIBUTE, and that union selector returns the first match in document
         order, which is the default option forever - the pair never moved off Pink. Read the
         live .checked PROPERTY instead. Caught on a local harness, not on the store. */
      var on = Array.prototype.filter.call(
        picker.querySelectorAll('input[type=radio]'), function (i) { return i.checked; })[0];
      var name = on ? on.value : '';
      if (!name) {
        var sel = picker.querySelector('select');
        if (sel) name = sel.value;
      }
      var hex = pairFromName(name);
      if (hex) setPair(hex);
    }
    /* Delegated, because Horizon re-renders the picker's contents on every variant change. */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.variant-picker')) sync();
    });
    sync();
  }

  /* Footer newsletter: DO NOT intercept this submit.

     DRO-91 §11b, corrected 9 Sep. I previously intercepted the submit and posted it with
     fetch to avoid the page load. That could never work, and the reason is worth keeping:
     Shopify guards /contact with an invisible CAPTCHA whose token is minted by Shopify's own
     native-submit flow. A fetch cannot produce one. Measured directly against the live
     endpoint - POST /contact with the exact form body returns

         400  <title>Missing CAPTCHA token</title>

     so every subscribe was paying a guaranteed-failed request before falling back to the
     native submit that was going to happen anyway. An earlier run read this as a Cloudflare
     bot challenge (403), because the automation fingerprint was challenged before the request
     ever reached Shopify; with that fingerprint removed the real 400 underneath was visible.

     The form is therefore left exactly as Shopify intends it. The founder's own fallback
     clause applies - "otherwise keep the scroll position and make sure the success message
     renders in place" - which is what restoreNewsletterAnchor() does on the page Shopify
     returns to. No-reload is not reachable on this endpoint from theme code alone.

  /* Sticky mobile buy bar: shows once the real buy block is off screen.

     DRO-97: the old selector list was `[data-bag-buy-anchor]` then `product-form, .product-form`.
     Horizon renders NEITHER on this product template, so querySelector returned null, initSticky
     returned before it observed anything, and the bar sat at translateY(110%) forever - measured
     at 390x844 and 360x780, scrolled to the end of the document. Horizon's real buy block is
     `.buy-buttons-block` (its own sticky bar observes exactly that element), wrapping
     `product-form-component` and `form[data-type="add-to-cart-form"]`. Take the first candidate
     that is NOT inside the bar, because the bar carries its own .shopify-product-form. */
  /* DRO-241: EVERY buy UI on the page is an anchor, not the first match. The two-bag tier
     hides the native buy-buttons block (display:none), and a zero-size anchor never
     intersects and reports top 0 - so the old single-anchor code parked the bar forever.
     The explicit [data-bag-buy-anchor] (the tiers wrapper) and the native block are both
     observed; whichever is hidden right now has no box and is ignored by barShouldShow(). */
  function findBuyAnchors(bar) {
    var list = document.querySelectorAll(
      '[data-bag-buy-anchor], .buy-buttons-block, product-form-component, form[data-type="add-to-cart-form"], product-form, .product-form'
    );
    var out = [];
    for (var i = 0; i < list.length; i++) {
      if (!bar.contains(list[i])) out.push(list[i]);
    }
    return out;
  }

  /* Show the bar only when every buy UI that has a box has scrolled off the TOP. None with
     a box = nothing to anchor to: stay parked and say so, instead of failing silently. */
  function barShouldShow(anchors) {
    var boxed = 0;
    for (var i = 0; i < anchors.length; i++) {
      var r = anchors[i].getBoundingClientRect();
      if (r.height <= 0 && r.width <= 0) continue;
      boxed++;
      if (r.bottom > 0) return false;
    }
    return boxed > 0;
  }

  /* Shopify Inbox launcher lift. The launcher is `.activator-nudge` inside the OPEN shadow root of
     <shopify-chat>, bottom:20px right:20px, and the button exposes part="activator" - so a light-DOM
     `::part(activator)` transform moves the button alone and leaves the chat drawer where it is.
     Measured before the fix at 390x844: launcher y 778-824, bar y 770-844, elementFromPoint at the
     launcher centre returned the bar. Lift is computed from the LIVE bar height, not the 82px
     constant in the ticket, because the bar's padding carries env(safe-area-inset-bottom) and is
     taller on a notched phone. Target: launcher bottom edge 12px above the bar, and the launcher
     already sits 20px up, so translateY = -(barHeight + 12 - 20). */
  function setChatLift(bar, visible) {
    var host = document.querySelector('shopify-chat');
    if (!host) return;
    /* A hidden bar has zero height (display:none at >=750px), which also switches the lift off on
       desktop, where the bar never paints. */
    var h = visible ? bar.getBoundingClientRect().height : 0;
    host.style.setProperty('--bag-chat-lift', h > 0 ? '-' + Math.round(h - 8) + 'px' : '0px');
  }


  /* DRO-221: ONE cart path for every Add to cart on the product page.

     Before this, the same store had three. Horizon's own buy button posts to
     /cart/add.js, dispatches the standard cart:lines-update event and lets the drawer
     open itself. The two-bag tier and the phone sticky bar each did a plain form POST
     instead, so those two buttons left the page for /cart while the one-bag button
     opened the drawer. The founder found it on his 21 Sep walk.

     This helper is the single path. It POSTs /cart/add.js, then resolves the standard
     event with the refreshed cart, so every listener - cart drawer auto-open, the cart
     badge count, the cart line items - reacts exactly as it does for the theme's own
     button. The event class is imported from the same module the theme itself uses, so
     the event is the real one, not a lookalike.

     Returns a promise that REJECTS when the add fails, so a caller can fall back to the
     native form submit and a failed add never dead-ends on a button that did nothing. */
  var EVENTS_MODULE = null;
  function standardEvents() {
    if (EVENTS_MODULE) return EVENTS_MODULE;
    EVENTS_MODULE = new Promise(function (resolve, reject) {
      if (window.__bagStandardEvents) return resolve(window.__bagStandardEvents);
      /* A dynamic import() written HERE does not survive: Shopify minifies theme JS
         assets and rewrote `import(...)` to `require(...)`, so the first live click
         failed with "require is not defined" and fell back to the full page POST.
         Measured on totebee.com, not guessed. An inline module script is a STRING to
         the minifier, so it reaches the browser intact, and it resolves the bare
         specifier against the theme's own import map - the same module instance the
         theme's own components use, not a second copy. */
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        window.__bagStandardEvents ? resolve(window.__bagStandardEvents)
                                   : reject(new Error('standard events module unavailable'));
      };
      document.addEventListener('bag:events-ready', finish, { once: true });
      var s = document.createElement('script');
      s.type = 'module';
      s.textContent =
        "import * as m from '@shopify/events';" +
        "window.__bagStandardEvents = m;" +
        "document.dispatchEvent(new Event('bag:events-ready'));";
      s.onerror = finish;
      document.head.appendChild(s);
      window.setTimeout(finish, 6000);
    });
    return EVENTS_MODULE;
  }

  function themeRoute(name, fallback) {
    var t = window.Theme;
    return (t && t.routes && t.routes[name]) || fallback;
  }

  /* The cart line-item sections to re-render, exactly as Horizon's product form asks for
     them, so the drawer morphs its markup instead of refetching the whole section. */
  function cartSectionIds() {
    var ids = [];
    Array.prototype.forEach.call(
      document.querySelectorAll('cart-items-component[data-section-id]'),
      function (el) { ids.push(el.dataset.sectionId); }
    );
    return ids.join(',');
  }

  /* items: [{ id: <variant id>, quantity: n }, ...]. source: the element to dispatch the
     event from; it only has to be in the document, because the event bubbles. */
  function bagCartAdd(items, source) {
    var el = source && source.isConnected ? source : document.body;
    return standardEvents().then(function (mod) {
      var CartLinesUpdate = mod.CartLinesUpdateEvent;
      var deferred = CartLinesUpdate.createPromise();
      var count = items.reduce(function (n, i) { return n + i.quantity; }, 0);

      el.dispatchEvent(new CartLinesUpdate({
        action: 'add',
        context: 'product',
        lines: items.map(function (i) {
          return { merchandiseId: String(i.id), quantity: i.quantity };
        }),
        promise: deferred.promise
      }));

      return fetch(themeRoute('cart_add_url', '/cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: items.map(function (i) { return { id: Number(i.id), quantity: i.quantity }; }),
          sections: cartSectionIds()
        })
      })
        .then(function (r) {
          return r.json().then(function (body) { return { ok: r.ok, status: r.status, body: body }; });
        })
        .then(function (res) {
          if (!res.ok || (res.body && res.body.status)) {
            var message = (res.body && (res.body.description || res.body.message)) || 'Add to cart failed';
            var err = new Error(message);
            /* DRO-54: the server said no. Callers MUST NOT retry this as a native form
               POST - see bagRefusedRecover below for why that path is unsafe. */
            err.refused = true;
            err.status = res.status;
            deferred.reject(err);
            throw err;
          }
          return fetch(themeRoute('cart_url', '/cart') + '.js', {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              deferred.resolve({
                cart: CartLinesUpdate.createCartFromAjaxResponse(cart),
                detail: {
                  items: cart.items,
                  source: 'bag-store',
                  sourceId: 'bag-cart-add',
                  itemCount: count,
                  sections: res.body.sections,
                  didError: false
                }
              });
              return cart;
            });
        })
        .catch(function (err) { deferred.reject(err); throw err; });
    });
  }
  window.bagCartAdd = bagCartAdd;

  /* DRO-54. When the cart REFUSES a line, the page the shopper is looking at is stale:
     it was rendered while that color was still in stock. The old code retried the same
     payload as a native form POST, which did two bad things. It bounced her to /cart with
     no explanation, and inside the seconds-wide window where the storefront cache still
     said yes it actually landed the dead line in the cart - so the next step fired
     InitiateCheckout into Meta at a checkout that could only ever show stock-problems.
     Reload instead: the server then re-renders the truth (disabled swatch, sold-out
     button) and one plain sentence is carried across the reload to say why. */
  var REFUSED_KEY = 'bag-sold-out-notice';

  function bagRefusedRecover(err) {
    var msg = (err && err.message) || '';
    if (!msg || /sold ?out|in stock|stock|available/i.test(msg)) {
      msg = 'Sorry, that color just sold out. Pick another color.';
    }
    try { sessionStorage.setItem(REFUSED_KEY, msg); } catch (e) {}
    location.reload();
  }
  window.bagRefusedRecover = bagRefusedRecover;

  function showRefusedNotice() {
    var msg = null;
    try {
      msg = sessionStorage.getItem(REFUSED_KEY);
      if (msg) sessionStorage.removeItem(REFUSED_KEY);
    } catch (e) { return; }
    if (!msg) return;
    var host = document.querySelector('.bag-tiers') ||
               document.querySelector('.buy-buttons-block') ||
               document.querySelector('.product-details');
    if (!host || !host.parentNode) return;
    var p = document.createElement('p');
    p.className = 'bag-soldout-notice';
    p.setAttribute('role', 'alert');
    p.textContent = msg;
    host.parentNode.insertBefore(p, host);
  }

  /* True only where an ajax add has somewhere to land. Without the drawer the native
     form POST to /cart is the better answer, so every caller checks this first. */
  function drawerReady() {
    return typeof window.bagCartAdd === 'function' && !!document.querySelector('cart-drawer-component[auto-open]');
  }

  /* The variant the buy box is actually showing. The sticky bar shipped with the
     SERVER-rendered id baked into a hidden input, so on the phone a shopper who switched
     to Pink and then used the sticky bar added White (DRO-221 item 4). The checked radio
     is the source of truth: it is the thing she clicked. */
  function currentVariantId(bar) {
    var radio = document.querySelector('variant-picker input[type=radio]:checked');
    if (radio && radio.dataset.variantId) return radio.dataset.variantId;
    var live = document.querySelector('.buy-buttons-block input[name="id"]');
    if (live && live.value) return live.value;
    var own = bar && bar.querySelector('input[name="id"]');
    return own && own.value;
  }

  function initStickyCart(bar) {
    var form = bar.querySelector('form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      /* DRO-241: under the two-bag tier the bar is the pair's button. Submit the tiers form
         through its own button, so the add, the drawer and every fallback are exactly the
         ones the buy box uses. */
      /* html.bag-two-default is written by the tiers block itself on every tier change, so
         it is right even in the instant before the bar has been re-labelled. */
      if (document.documentElement.classList.contains('bag-two-default')) {
        var tf = document.querySelector('.bag-tiers__form');
        if (tf) {
          e.preventDefault();
          var tb = tf.querySelector('.bag-tiers__add');
          if (tb && tb.disabled) return;
          if (tf.requestSubmit) tf.requestSubmit(tb || undefined);
          else if (tb) tb.click();
          return;
        }
      }
      var id = currentVariantId(bar);
      if (!drawerReady() || !id) return; /* native POST to /cart, unchanged */
      e.preventDefault();
      var btn = form.querySelector('button[type=submit]');
      var own = form.querySelector('input[name="id"]');
      if (own) own.value = id;
      if (btn) btn.setAttribute('aria-busy', 'true');
      window.bagCartAdd([{ id: id, quantity: 1 }], form)
        .catch(function (err) {
          /* DRO-54: only a transport failure earns the native POST fallback. */
          if (err && err.refused) return bagRefusedRecover(err);
          form.submit();
        })
        .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    });
  }

  function initSticky(bar) {
    initStickyCart(bar);
    var anchors = findBuyAnchors(bar);
    if (!anchors.length || !('IntersectionObserver' in window)) {
      if (window.console) console.warn('bag-sticky: no buy anchor on this page, bar stays parked');
      return;
    }
    var shown = false;
    var update = function () {
      var next = barShouldShow(anchors);
      if (next === shown) return;
      shown = next;
      bar.classList.toggle('is-visible', shown);
      setChatLift(bar, shown);
    };
    var io = new IntersectionObserver(update, { threshold: 0 });
    anchors.forEach(function (a) { io.observe(a); });
    /* A tier switch hides one anchor and shows another without scrolling. */
    document.addEventListener('change', function () { window.requestAnimationFrame(update); });
    /* The observer does not re-fire on a rotate or a resize across the 750px breakpoint, so the
       lift would stay applied on a desktop width where the bar is display:none. */
    window.addEventListener('resize', function () { setChatLift(bar, shown); });
    /* <shopify-chat> is upgraded by the Inbox bundle after our boot, so re-apply once it exists. */
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('shopify-chat').then(function () { setChatLift(bar, shown); });
    }
  }

  /* If we DID come back through the reload path, land at the footer with no visible travel.
     Horizon scrolls an inner .page-wrapper, so a plain #newsletter anchor does not move the
     page at all - measured: url became /?country=US#newsletter with the block still at y=1208,
     off screen. Restore the position on the real scroller instead, before paint. */
  function restoreNewsletterAnchor() {
    if (location.hash !== '#newsletter' && location.hash !== '#contact_form' &&
        location.search.indexOf('customer_posted=true') === -1) return;
    var block = document.getElementById('newsletter') || document.querySelector('.email-signup-block');
    if (!block) return;
    var sc = block.parentElement;
    while (sc && sc !== document.body) {
      var oy = getComputedStyle(sc).overflowY;
      if (oy === 'auto' || oy === 'scroll') break;
      sc = sc.parentElement;
    }
    var top = block.getBoundingClientRect().top;
    if (sc && sc !== document.body) sc.scrollTop += top - 40;
    else window.scrollTo(0, window.scrollY + top - 40);
    var msg = block.querySelector('.email-signup__message');
    if (msg && msg.focus) msg.focus({ preventScroll: true });
  }

  /* ===== DRO-204. Flag the cutouts, so the CSS can stop reading filenames ====
     September 19, 2026. bag-store.css used to key every cutout rule on the substring
     `hero-cutout` in the src. Batch 2 retires those names (the new files are `B2_...`),
     and a file that is a cutout but is not called one gets no drop shadow - which on the
     home carry row leaves the bag separating from #E0DCE1 by about 3 L. So the CSS keys
     on the attribute data-cutout now, and this is where the attribute comes from.

     Two tests, and BOTH must pass:

     1. an authored token in the src. This is the editorial half, and it has to be
        authored: transparency alone cannot decide it. S4/S5/S6 and the A6b/A7c/A8b carry
        shots are transparent too, and they deliberately carry NO shadow (DRO-122,
        DRO-173) - they are model shots cropped by the camera frame, so an alpha shadow
        would trace the crop and outline a rectangle the photo does not have. Only a
        human can say which transparent file is a free-standing bag. CUTOUT_TOKENS is
        that decision, in one place. `B2_` is already in it, so the batch 2 install needs
        no code change: the files land flagged.
     2. a real alpha read. Draws the decoded image into a 64x64 canvas and counts pixels
        with alpha < 16. Under 2% of them and the flag is NOT set. This half can only
        veto, never invent: drop-shadow on an opaque element traces its box, so a
        token-named file that ships opaque by mistake must not get the shadow. Today the
        live files sit at 42-72% against 0.00%, nowhere near the line.

     The images are served from totebee.com/cdn/..., same origin as the page, so the
     canvas is not tainted and getImageData is allowed. Do NOT add img.crossOrigin - it
     turns the request into CORS and Shopify's CDN does not need it. If the read throws
     anyway, the token decides alone, which is exactly today's behaviour.

     Horizon REPLACES the whole media-gallery node on a variant change and the home picker
     swaps src in place, so this cannot be a one-shot on load: a MutationObserver re-runs
     it on added nodes and on src changes. Re-running is cheap - a flagged img is skipped,
     and only a token match ever reaches the canvas. ===== */
  var CUTOUT_TOKENS = ['hero-cutout', 'B2_'];
  /* DRO-206 (September 19, 2026). The second authored list, and the counterpart to the one
     above: these files ARE cutouts, and they must NOT be shadowed. A drop-shadow traces
     whatever the element paints, so on a photo the camera frame has cropped it draws the
     crop as a shelf rather than the bag. The three batch 2 carry panels are cropped at the
     chin and the thigh; the d-ring macro is cropped into the bag on all four sides. Same
     rule as S4/S5/S6 and A6b/A7c/A8b before them - only now it is written down instead of
     relying on those files missing the token. Matching srcs get data-cropped, and every
     panel arm in bag-store.css is `[data-cutout]:not([data-cropped])`. Keep this list and
     CUTOUT_TOKENS together: between them they are the whole editorial decision. */
  var CROPPED_TOKENS = ['B2_carry-hand', 'B2_carry-shoulder', 'B2_carry-back', 'B2_dring-macro'];
  /* .bag-panel--tile and the top hero joined the selector with batch 2: both now serve
     transparent files, and neither could be flagged before because neither was looked at. */
  var CUT_SEL = 'media-gallery img, .bag-picker .bag-media img, .bag-panel--carry img,' +
                ' .bag-panel--tile img, [data-bag-hero-section] .bag-media img';
  /* Last src this img was decided for, kept as a property rather than an attribute so the
     decision cache adds no markup and cannot retrigger the observer. */
  var CUT_SEEN = '_bagCutoutSrc';

  function hasCutoutToken(src) {
    var s = String(src || '');
    for (var i = 0; i < CUTOUT_TOKENS.length; i++) {
      if (s.indexOf(CUTOUT_TOKENS[i]) !== -1) return true;
    }
    return false;
  }

  /* Fraction of pixels with alpha < 16, sampled at 64x64. Returns -1 when the pixels
     cannot be read at all, which the caller treats as "token decides". */
  function alphaFraction(img) {
    try {
      var n = 64;
      var c = document.createElement('canvas');
      c.width = n; c.height = n;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      if (!ctx) return -1;
      ctx.clearRect(0, 0, n, n);
      ctx.drawImage(img, 0, 0, n, n);
      var d = ctx.getImageData(0, 0, n, n).data;
      var clear = 0;
      for (var i = 3; i < d.length; i += 4) { if (d[i] < 16) clear++; }
      return clear / (n * n);
    } catch (e) { return -1; }
  }

  function isCropped(src) {
    var s = String(src || '');
    for (var i = 0; i < CROPPED_TOKENS.length; i++) {
      if (s.indexOf(CROPPED_TOKENS[i]) !== -1) return true;
    }
    return false;
  }

  function flagOne(img) {
    var src = img.currentSrc || img.getAttribute('src') || '';
    if (!src) return;
    /* Set before the cache check and before any decode: data-cropped is a pure filename
       test with no pixels in it, so it must never wait on a load that may not come. */
    if (isCropped(src)) img.setAttribute('data-cropped', '');
    else if (img.hasAttribute('data-cropped')) img.removeAttribute('data-cropped');
    if (img[CUT_SEEN] === src) return;                 /* same file, already decided */
    if (!hasCutoutToken(src)) {
      img[CUT_SEEN] = src;
      if (img.hasAttribute('data-cutout')) img.removeAttribute('data-cutout');
      return;
    }
    var decide = function () {
      var f = alphaFraction(img);
      if (f < 0 || f >= 0.02) img.setAttribute('data-cutout', '');
      else img.removeAttribute('data-cutout');
      img[CUT_SEEN] = img.currentSrc || img.getAttribute('src') || src;
    };
    /* Only ever decide on a LOADED image. The zoom dialog holds a lazy copy of every
       gallery file whose pixels are not fetched until the dialog opens, and decode() on
       one of those stays pending for ever - while a canvas read of an unloaded image
       would come back 100% transparent and flag it for the wrong reason. */
    var ready = function () {
      if (img.decode) img.decode().then(decide, decide);
      else decide();
    };
    if (img.complete && img.naturalWidth) ready();
    else img.addEventListener('load', ready, { once: true });
  }

  function flagCutouts(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('img')) { flagOne(scope); return; }
    Array.prototype.forEach.call(scope.querySelectorAll(CUT_SEL), flagOne);
  }

  function initCutouts() {
    flagCutouts(document);
    if (!window.MutationObserver) return;
    var pending = false;
    var run = function () {
      pending = false;
      flagCutouts(document);
    };
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      /* setTimeout, not requestAnimationFrame: a window method called off the object
         throws Illegal invocation in Chrome, and a bind here buys nothing. */
      window.setTimeout(run, 0);
    }).observe(document.documentElement, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset']
    });
  }

  function boot() {
    document.querySelectorAll('[data-bag-hero-section]').forEach(initHero);
    document.querySelectorAll('[data-bag-scroll-section]').forEach(initScroll);
    document.querySelectorAll('[data-bag-picker]').forEach(initPicker);
    document.querySelectorAll('[data-bag-sticky]').forEach(initSticky);
    initVariantPair();
    initCutouts();
    restoreNewsletterAnchor();
    showRefusedNotice();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();




